import enSignature from '../../assets/images/esl/valkartechEslSignature_EN.png';
import frSignature from '../../assets/images/esl/valkartechEslSignature_FR.png';
import esSignature from '../../assets/images/esl/valkartechEslSignature_ES.png';
import frenSignature from '../../assets/images/esl/valkartechEslSignature_FREN.png';
import enfrSignature from '../../assets/images/esl/valkartechEslSignature_ENFR.png';
import { EEslDatetimeLanguage } from '../../models/enums/eslDatetimeLanguage';
import { EEslTemplateElementType } from '../../models/enums/eslTemplateType';
import IEslTemplate from '../../models/esl/eslTemplate';

const signatureByLanguage = new Map<EEslDatetimeLanguage, string>([
    [EEslDatetimeLanguage.English, enSignature],
    [EEslDatetimeLanguage.French, frSignature],
    [EEslDatetimeLanguage.Spanish, esSignature],
    [EEslDatetimeLanguage.BilingualFrenchEnglish, frenSignature],
    [EEslDatetimeLanguage.BilingualEnglishFrench, enfrSignature],
]);

export const getEslSignature = (template: IEslTemplate): string => {
    const language = template.elements.find((element) => element.type === EEslTemplateElementType.LastCleaningDatetime)?.language;

    return signatureByLanguage.get(language ?? EEslDatetimeLanguage.English) ?? enSignature;
};
